module.exports = __webpack_public_path__ + "img/05.eb1989c2.png";